import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDialogStore = defineStore('dialog', () =>{
    const active = ref('');
    const preventClose = ref(false);

    const showDialog = (dialog) => {
        if (typeof document === 'undefined') return;

        const popup =  document.querySelector('#popup');
        if (typeof(popup) != 'undefined' && popup != null) {
            document.querySelector('#popup').classList.remove('active');
        }

        const body = document.querySelector('body');
        body.classList.add('overflow');

        active.value = dialog;
    };

    const hideDialog = () => {
        const body = document.querySelector('body');
        body.classList.remove('overflow');

        active.value = '';
    };

    const preventCloseDialog = () => {
        preventClose.value = true;
    };

    return {
        active,
        preventClose,
        showDialog,
        hideDialog,
        preventCloseDialog,
    };
});
